import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import { FaAngleDown } from "react-icons/fa6";
import { RiFileDownloadLine } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import CustomTabs from "../../Components/Common/CustomTabs";
import AllDelivery from "../../Components/Delivery/AllDelivery";
import AllDriver from "../../Components/Delivery/AllDriver";
import OverviewCard from "../../Components/App/OverviewCard";
import { useQuery } from "@apollo/client";
import {
  GET_DELIVERIES,
  GET_DELIVERY_STATS,
  GET_DRIVERS,
} from "../../Utils/Queries";
import Loader from "../../Components/Common/Loader";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { LiaBoxSolid } from "react-icons/lia";

const Delivery = () => {
  const [value, setValue] = React.useState(0);
  const [searchParams, setSearchParams] = useState("");

  const [deliveryData, setDeliveryData] = useState([]);
  const [metricsData, setMetricsData] = useState({});
  const [driversData, setDriversData] = useState([]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { data: delivery_data, loading: loadingDeliveries } = useQuery(
    GET_DELIVERIES,
    {
      variables: {
        pageOptions: {
          page: 1,
          limit: 100,
        },
      },
    }
  );

  const { data: driver_data, loading: loadingDrivers } = useQuery(GET_DRIVERS);

  const {
    data: metrics,
    loading: metricsLoading,
    error: metricsError,
  } = useQuery(GET_DELIVERY_STATS);

  useEffect(() => {
    setDeliveryData(delivery_data?.fetchDeliveriesWithFilter?.items);
    setDriversData(driver_data?.fetchDriversWithFilter?.items);
    setMetricsData(metrics?.fetchDeliveryStats);
  }, [delivery_data, metrics]);

  const TabData = [
    {
      label: "Deliveries",
      component: <AllDelivery data={deliveryData} />,
    },
    {
      label: "Drivers",
      component: <AllDriver data={driversData} />,
    },
  ];

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();

    // Filter items based on the search term
    const filteredItems =
      delivery_data?.fetchDeliveriesWithFilter?.items?.filter((item) =>
        item?.user?.firstName.toLowerCase().includes(searchTerm)
      );

    setDeliveryData(filteredItems);
    setSearchParams(searchTerm);
  };

  const generatePDF = () => {
    const doc = new jsPDF();

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);

    // Add heading
    doc.text(`Mamaket Transaction List - ${formatDate(new Date())}`, 10, 10);
    // Set custom font and size for the table
    doc.setFont("helvetica");
    doc.setFontSize(12);

    const tableColumn = [
      "Order ID",

      "Product",
      "Assigned Driver",
      "Delivery Price",
      "Date",
      "Status",
    ];
    const tableRows = [];

    deliveryData.forEach((item) => {
      const itemData = [
        item._id,
        item.product?.name,
        item.driver || "N/A",
        item.orderItem.amountPaid,
        formatDate(item?.createdAt),
        item.orderItem.status,
      ];
      tableRows.push(itemData);
    });

    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 15,
      styles: {
        fontSize: 6,
        font: "helvetica",
      },
      headStyles: {
        fillColor: [92, 48, 105],
      },
    });

    doc.save(`mamaket_TL(${new Date()}).pdf`);
  };

  return (
    <>
      {loadingDrivers || (loadingDeliveries && <Loader />)}
      <Grid container spacing={3}>
        <Grid item lg={3} md={3}>
          <OverviewCard
            title="Total Delivery"
            icon={<LiaBoxSolid />}
            value={`${metricsData?.noOfTotalDeliveries || 0}`}
          />
        </Grid>
        <Grid item md={3}>
          <OverviewCard
            title="Pending Delivery"
            icon={<LiaBoxSolid />}
            value={`${metricsData?.noOfPendingDeliveries || 0}`}
          />
        </Grid>
        <Grid item md={3}>
          <OverviewCard
            title="Completed Delivery"
            icon={<LiaBoxSolid />}
            value={`${metricsData?.noOfCompletedDeliveries || 0}`}
          />
        </Grid>
        <Grid item md={3}>
          <OverviewCard
            title="Total Drivers"
            icon={<LiaBoxSolid />}
            value={`${metricsData?.noOfTotalDrivers || 0}`}
          />
        </Grid>
      </Grid>
      <Box sx={{ bgcolor: "#fff", p: 2, mt: 3 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 3,
          }}
        >
          <TextField
            placeholder="Search by ID, product, or others..."
            sx={{ width: "70%" }}
            value={searchParams}
            onChange={handleSearch}
            size="small"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <FiSearch style={{ fontSize: "18px" }} />
                </InputAdornment>
              ),
              style: {
                background: " #F8F7F7",
                fontWeight: 400,
                fontSize: "13px",
                borderRadius: "5px",
                border: 0,
                offset: " 0px solid #f2f2f2",
              },
            }}
          />
          <Box
            sx={{
              width: "15%",
              bgcolor: "#F8F7F7",
              fontSize: "12px",
              py: 1,
              display: "flex",
              columnGap: 1,
              alignItems: "center",
              borderRadius: 1,
              justifyContent: "center",
              px: 2,
            }}
          >
            <Typography sx={{ color: "#666", fontWeight: 400 }}>
              All Status{" "}
            </Typography>
            <FaAngleDown style={{ color: "#666" }} />
          </Box>
          <Box
            sx={{
              width: "15%",
              bgcolor: "#F8F7F7",
              fontSize: "12px",
              py: 1,
              display: "flex",
              columnGap: 1,
              alignItems: "center",
              borderRadius: 1,
              justifyContent: "center",
              px: 2,
            }}
          >
            <Typography sx={{ color: "#666", fontWeight: 400 }}>
              Today{" "}
            </Typography>
            <FaAngleDown style={{ color: "#666" }} />
          </Box>
          <Button
            onClick={generatePDF}
            endIcon={<RiFileDownloadLine style={{ color: "#666" }} />}
            sx={{
              color: "#666",
              bgcolor: "#F8F7F7",
              width: "10%",
              py: 1,
              px: 8,
              fontSize: "12px",
            }}
          >
            Download
          </Button>
        </Box>

        <Box sx={{ mt: 4 }}>
          <CustomTabs
            value={value}
            handleChange={handleChange}
            data={TabData}
            variant="standard"
          />
        </Box>
      </Box>
    </>
  );
};

export default Delivery;

const formatDate = (dateString) => {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getUTCFullYear();

  return `${day} ${month} ${year}`;
};
